(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('StatementTypeDeleteController',StatementTypeDeleteController);

    StatementTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'StatementType'];

    function StatementTypeDeleteController($uibModalInstance, entity, StatementType) {
        var vm = this;

        vm.statementType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            StatementType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
